import MyRecipeBookPage from "./MyRecipeBookPage";

export default MyRecipeBookPage;